/* The partner banks, in the order the floor names them.

   Only the name reaches the site. The three numbers below never appear on a
   card: they exist so the lease calculator can seed a markup rate when a
   visitor picks a bank, and so it can say when a down payment or a tenure is
   outside what that bank will write. A rate quoted on a card is a rate the
   bank has to honour; a rate that only seeds a slider the visitor then drags
   is what it is — indicative, and labelled as such where it shows. */

export type Bank = {
  id: string
  name: string
  /** Indicative annual markup, as a rate — 0.1495 is 14.95%. Seeds the
      calculator's slider; never rendered as a quoted figure. */
  apr: number
  /** Minimum down payment the bank will accept, as a share of price. */
  minDownRate: number
  maxTenureYears: number
}

export const BANKS: Bank[] = [
  {
    id: 'askari',
    name: 'Askari Bank',
    apr: 0.159,
    minDownRate: 0.25,
    maxTenureYears: 7,
  },
  {
    id: 'faysal',
    name: 'Faysal Bank',
    apr: 0.1495,
    minDownRate: 0.3,
    maxTenureYears: 7,
  },
  {
    id: 'standard-chartered',
    name: 'Standard Chartered',
    apr: 0.165,
    minDownRate: 0.2,
    maxTenureYears: 5,
  },
  {
    id: 'ubl',
    name: 'UBL',
    apr: 0.1675,
    minDownRate: 0.2,
    maxTenureYears: 5,
  },
  {
    id: 'al-habib',
    name: 'Bank AL Habib',
    apr: 0.1575,
    minDownRate: 0.2,
    maxTenureYears: 7,
  },
  {
    id: 'alfalah',
    name: 'Bank Alfalah',
    apr: 0.155,
    minDownRate: 0.2,
    maxTenureYears: 7,
  },
  {
    id: 'js',
    name: 'JS Bank',
    apr: 0.1525,
    minDownRate: 0.25,
    maxTenureYears: 5,
  },
  {
    id: 'bop',
    name: 'BOP',
    apr: 0.1625,
    minDownRate: 0.2,
    maxTenureYears: 7,
  },
]

export const DEFAULT_BANK = BANKS[0]
